import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';

export const isTaskChecked = (task) => nullSafeGetOrElse('answer', task, 'false') === 'true';

export const getPendingUnlinkedTaskItems = (task) =>
	nullSafeGetOrElse('taskListAnswer', task, []).filter(
		(ti) => !isTaskChecked(ti) && !nullSafeGet('linkedWorkOrderTaskItemId', ti)
	);

export const canCheckTask = (task, currentUser) => {
	const checkableByUser = isTaskChecked(task) ? task.answeredBy === currentUser.email : true;
	const checkableByLink = !nullSafeGet('linkedWorkOrderTaskItem.workOrderId', task);
	return checkableByUser && checkableByLink;
};
